import React, { createContext, useContext, useState, useEffect } from 'react';
import { io } from "socket.io-client";

const WebsocketContext = createContext()

export const useWebsocket = () => {
    return useContext(WebsocketContext)
}

export const WebsocketProvider = ({ children }) => {
    const [socket, setSocket ] = useState(null)
    const [isConnected, setIsConnected ] = useState(false)

    useEffect(() => {
        const inicializarSocket = () => {
            const nuevoSocket = io(process.env.REACT_APP_WEBSOCKET_TRACKING, {
                transports: ["websocket", "polling"],
                auth: { token: "dHJhY2tlby11bmlkYWRlcy13ZWJhcGk=" },
                autoConnect: true
            })

            nuevoSocket.on('connect', () => {
                console.log('Conectado al Servidor WebSocket', nuevoSocket.id)
                setIsConnected(true)
            })

            nuevoSocket.on('disconnect', (razon) => {
                console.log('Desconectado del Servidor WebSocket', razon)
                setIsConnected(false)
            })

            nuevoSocket.on('connect_error', (error) => {
                console.log('Error de conexion del Servidor WebSocket', error)
                setIsConnected(false)
            })

            return nuevoSocket
        }
        const nuevoSocket = inicializarSocket()
        setSocket(nuevoSocket)

        return () => {
            nuevoSocket.disconnect()
        }
        
    }, [])

    const value = {
        socket,
        isConnected
    }

    return(
        <WebsocketContext.Provider value={value}>
            {children}
        </WebsocketContext.Provider>
    )
}